import { ArrowRight, CheckCircle2, Database, ExternalLink, LockKeyhole, Scale, ShieldCheck } from 'lucide-react';

const lanes = [
  {
    label: 'Lane 1',
    title: 'Analytics & tools',
    status: 'Launch first',
    icon: Database,
    items: ['Market maps and factual screeners', 'User-defined alerts', 'Paper trading with virtual funds', 'Source-linked filing monitor'],
  },
  {
    label: 'Lane 2',
    title: 'Research services',
    status: 'RA registration',
    icon: Scale,
    items: ['Stock-specific ideas or calls', 'IPO subscribe/avoid opinions', 'Target prices and model research baskets', 'Research reports and analyst webinars'],
  },
  {
    label: 'Lane 3',
    title: 'Personal advice',
    status: 'IA registration',
    icon: LockKeyhole,
    items: ['Risk profiling and suitability', 'Client-specific allocation', 'Personal portfolio recommendations', 'Ongoing advice and reviews'],
  },
];

const officialSources = [
  ['SEBI RA Master Circular · 6 Feb 2026', 'https://www.sebi.gov.in/legal/master-circulars/feb-2026/master-circular-for-research-analysts_99571.html'],
  ['SEBI IA Master Circular · 6 Feb 2026', 'https://www.sebi.gov.in/legal/master-circulars/feb-2026/master-circular-for-investment-advisers_99569.html'],
  ['SEBI educational price-data norms · 8 May 2026', 'https://www.sebi.gov.in/sebi_data/attachdocs/may-2026/1778242522289.pdf'],
  ['NSE Data Sharing & Usage Policy', 'https://www.nseindia.com/static/market-data/nse-data-policy'],
  ['Digital Personal Data Protection Rules, 2025', 'https://www.meity.gov.in/documents/act-and-policies/digital-personal-data-protection-rules-2025-gDOxUjMtQWa'],
];

export default function TrustCompliance() {
  return (
    <div className="page-stack trust-page">
      <section className="page-heading compact-page-heading">
        <div><div className="eyebrow"><ShieldCheck size={12} /> Trust by design</div><h1>Compliance is a product feature</h1><p>Visible labels, registration gates, licensed data and audit-ready workflows protect users and the business.</p></div>
        <a className="subtle-button" href="https://scores.sebi.gov.in/" target="_blank" rel="noreferrer">SEBI SCORES <ExternalLink size={14} /></a>
      </section>
      <section className="lane-grid" id="regulatory-lanes">
        {lanes.map((lane) => {
          const Icon = lane.icon;
          return <article className="surface-card lane-card" key={lane.label}><div className="lane-top"><span className="product-icon"><Icon size={20} /></span><em>{lane.label}</em></div><h2>{lane.title}</h2><span className="lane-status">{lane.status}</span><ul>{lane.items.map((item) => <li key={item}><CheckCircle2 size={15} /> {item}</li>)}</ul></article>;
        })}
      </section>
      <section className="compliance-grid">
        <article className="surface-card compliance-checklist">
          <div className="card-header"><div><h2>Pre-launch gates</h2><p>Do not convert a feature from “planned” to “live” until its gate is evidenced.</p></div></div>
          <ol>
            <li><span>01</span><div><strong>Legal classification memo</strong><p>Classify every insight, notification, score and marketing claim.</p></div></li>
            <li><span>02</span><div><strong>Data rights register</strong><p>Record provider, permitted display, delay, redistribution and retention terms.</p></div></li>
            <li><span>03</span><div><strong>Registration verification</strong><p>Publish the registered name and number only after approval; never imply registration.</p></div></li>
            <li><span>04</span><div><strong>Research audit trail</strong><p>Version sources, assumptions, conflicts, approvals, corrections and client delivery.</p></div></li>
            <li><span>05</span><div><strong>Privacy and incident readiness</strong><p>Consent, purpose limits, rights handling, secure retention and CERT-In response.</p></div></li>
          </ol>
        </article>
        <article className="surface-card source-register">
          <div className="card-header"><div><h2>Primary regulatory sources</h2><p>Baseline checked 3 September 2026. Recheck before launch.</p></div></div>
          {officialSources.map(([label, url]) => <a href={url} key={url} target="_blank" rel="noreferrer"><span>{label}</span><ArrowRight size={14} /></a>)}
          <div className="legal-note"><ShieldCheck size={17} /><p>This is a product compliance framework, not a legal opinion. Obtain Indian securities counsel and compliance-officer sign-off.</p></div>
        </article>
      </section>
    </div>
  );
}
